import { toast as sonnerToast, Toaster } from "sonner";
import { Button } from "@oai/platform/ui/Button";
import { CheckCircleFilled, Info, Warning, X } from "@oai/platform/ui/Icon";

import s from "./toaster.module.css";

import type { ReactNode } from "react";
import type { ExternalToast } from "sonner";

type ToastSettings = {
  description?: ReactNode;
  duration?: number;
  action?: ReactNode;
};

function getToastOptions(settings: ToastSettings = {}): ExternalToast {
  const id = Math.random().toString(36);
  return {
    duration: 5000,
    ...settings,
    id,
    action: (
      <>
        {settings.action}
        <Button
          color="primary"
          onClick={(e) => {
            e.stopPropagation();
            sonnerToast.dismiss(id);
          }}
          uniform={true}
          variant="ghost"
        >
          <X />
        </Button>
      </>
    ),
  };
}

export const toaster = {
  info(title: ReactNode, settings?: ToastSettings) {
    return sonnerToast.info(title, getToastOptions(settings));
  },
  success(title: ReactNode, settings?: ToastSettings) {
    return sonnerToast.success(title, getToastOptions(settings));
  },
  warning(title: ReactNode, settings?: ToastSettings) {
    return sonnerToast.warning(title, getToastOptions({ duration: Infinity, ...settings }));
  },
  error(title: ReactNode, settings?: ToastSettings) {
    return sonnerToast.error(title, getToastOptions({ duration: Infinity, ...settings }));
  },
  dismiss(id: string | number) {
    sonnerToast.dismiss(id);
  },
};

export function AppToaster() {
  return (
    <Toaster
      className={s.Toaster}
      position="bottom-right"
      visibleToasts={4}
      icons={{
        error: <Warning />,
        info: <Info />,
        success: <CheckCircleFilled />,
        warning: <Warning />,
        close: <X />,
      }}
    />
  );
}
